import { Component, ElementRef, HostListener, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import {gsap} from 'gsap';
import { CursorService } from 'src/app/services/cursor_animation/cursor.service';


@Component({
    selector: 'app-nav-pages',
    templateUrl: './nav-pages.component.html',
    styleUrls: ['./nav-pages.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavPagesComponent implements OnInit {
  @Input() solidNav: boolean = false
  isScrolled: boolean = false

  logoImage: string = "assets/imgs/Zumeralogo-WHITE.png"

  @ViewChild('offcanvasNavbar') offcanvasNavbar!: ElementRef ;

  constructor(private cursorService: CursorService) {

  }

  ngOnInit(): void {
    if (this.solidNav) {
      this.logoImage = "assets/imgs/zumera-logo-red.png";
      this.isScrolled = true;
    }
  }
  
  ngAfterViewInit(): void {
    const navbar = this.offcanvasNavbar.nativeElement
    const observer = new MutationObserver(mutations => {
      mutations.forEach((mutation:any) => {
        if (mutation.attributeName === 'class' && mutation.target.classList.contains('hiding')) {
          gsap.to(".nav-link", {
            opacity: 1,
            x: 300, 
            duration: 0.5,
            ease: "power2.out",
            // visibility: "hidden",
            stagger: {
              amount: 0.5, // Base stagger amount
              from: "end" // Controls where the stagger starts
            },
            onComplete: () =>{
              gsap.set(".nav-link", { visibility: "hidden" });
            }
          });
        }
      });
    });

    observer.observe(navbar, { attributes: true });
  }

  
  onMouseEnter(): void {
    this.cursorService.hoverElement();
  }

  onMouseLeave(): void {
    this.cursorService.unhoverElement();
  }
  slideNavlinks(){
    if (this.offcanvasNavbar) {
      gsap.to(".nav-link", {
        opacity: 1,
        x: 0,
        duration: 0.5,
        stagger: {
          amount: 1, // Base stagger amount
          from: "start" // Controls where the stagger starts
        },
        ease: "power2.out",
        visibility: "visible"
      });
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event): void {
    const navElement = document.querySelector('nav');
    const logo =  document.getElementById('company-logo')
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    const menuBtn = document.getElementById('menuBtn')


    if(navElement){

      if (scrollPosition > 200) {
        navElement.style.backgroundColor = "#fff"
        this.isScrolled = true
        this.logoImage = "assets/imgs/zumera-logo-red.png"
        if(menuBtn) menuBtn.style.color = '#000'

      } else if (!this.solidNav) {
        navElement.style.backgroundColor = "transparent"
        this.logoImage = "assets/imgs/Zumeralogo-WHITE.png"
        this.isScrolled = false
        if(menuBtn) menuBtn.style.color = '#fff'
        
      }
    }
    
  }

}
